var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jzliu-bi-engine-dws-table" },
    [
      _c(
        "el-table",
        {
          staticClass: "table-header-gray",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, "max-height": _vm.tableHeight },
        },
        _vm._l(_vm.columns, function (item) {
          return _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "180",
              prop: item.prop,
              label: item.label,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          "current-page": _vm.queryList.pageNum,
          "page-size": _vm.queryList.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.queryList.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }